export default __webpack_public_path__ + "static/media/moda-img.f94f87a2.svg";